'use client';

import { PageTitleHandler } from 'reservations/account/components/PageTitleHandler';
import { AccessTokenProvider } from 'reservations/account/providers/AccessTokenProvider';
import { ConfigProvider } from 'reservations/account/providers/ConfigProvider';

type NextableProviderProps = {
  slug: string;
  children?: React.ReactNode;
};

const NextableProvider = ({ slug, children }: NextableProviderProps) => (
  <AccessTokenProvider slug={slug}>
    <ConfigProvider>
      <PageTitleHandler>{children}</PageTitleHandler>
    </ConfigProvider>
  </AccessTokenProvider>
);

export default NextableProvider;
